export default __webpack_public_path__ + "static/media/AWLA.ded8206c.jpg";